// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --c-bkg-body: #f8f9fa;
  --c-bkg-card: #ffffff;
  --c-bkg-sidebar: #ffffff;

  --c-text-base: #212529;
  --c-text-muted: #6c757d;

  --c-border: #e2e5e8;

  --c-primary: #4b7cf3;
  --c-primary-hover: #3a6bd8;
  --c-secondary: #6c757d;
  --c-secondary-hover: #5a6268;
  --c-success: #2ecc71;
  --c-danger: #e74c3c;
  
  /* Vector map colors */
  --vmap-bg-color: #ffffff;
  --vmap-border-color: #ffffff;
  --vmap-region-color: #e4ecef;
  --vmap-marker-fill: #ffffff;
  --vmap-marker-stroke: #000000;
  --vmap-hover-color: #ffffff;
  --vmap-selected-color: #c9dfaf;
  --vmap-scale-start: #03a9f3;
  --vmap-scale-end: #02a7f1;
  --vmap-scale-light: #b6d6ff;
  --vmap-scale-dark: #005ace;
  
  /* Skycons */
  --skycons-color: #ff6849;
  
  /* Sparkline colors */
  --sparkline-success: #4caf50;
  --sparkline-purple: #9675ce;
  --sparkline-info: #03a9f3;
  --sparkline-danger: #f96262;
  --sparkline-light: #aaf;
  
  /* Loader */
  --loader-bg: #ffffff;
  --spinner-bg: #333333;
  
  /* Google Maps */
  --gmap-landscape-hue: #FFBB00;
  --gmap-highway-hue: #FFC200;
  --gmap-road-hue: #FF0300;
  --gmap-water-hue: #0078FF;
  --gmap-poi-hue: #00FF6A;
}

[data-theme="dark"] {
  --c-bkg-body: #181a1f;
  --c-bkg-card: #20232a;
  --c-bkg-sidebar: #20232a;

  --c-text-base: #e8eaed;
  --c-text-muted: #9ca3af;

  --c-border: #2b2f36;

  --c-primary: #4b7cf3;
  --c-primary-hover: #3a6bd8;
  --c-secondary: #6c757d;
  --c-secondary-hover: #5a6268;
  --c-success: #32d48e;
  --c-danger: #ff6b6b;
  
  /* Vector map colors - dark theme */
  --vmap-bg-color: #20232a;
  --vmap-border-color: #2b2f36;
  --vmap-region-color: #2b2f36;
  --vmap-marker-fill: #e8eaed;
  --vmap-marker-stroke: #9ca3af;
  --vmap-hover-color: #181a1f;
  --vmap-selected-color: #4b5563;
  --vmap-scale-start: #3b82f6;
  --vmap-scale-end: #1d4ed8;
  --vmap-scale-light: #1e40af;
  --vmap-scale-dark: #60a5fa;
  
  /* Skycons - dark theme */
  --skycons-color: #f97316;
  
  /* Sparkline colors - dark theme */
  --sparkline-success: #10b981;
  --sparkline-purple: #a855f7;
  --sparkline-info: #3b82f6;
  --sparkline-danger: #ef4444;
  --sparkline-light: #60a5fa;
  
  /* Loader - dark theme */
  --loader-bg: #181a1f;
  --spinner-bg: #e8eaed;
  
  /* Google Maps - dark theme */
  --gmap-landscape-hue: #D4AC0D;
  --gmap-highway-hue: #E6AC00;
  --gmap-road-hue: #CC2900;
  --gmap-water-hue: #1B4F72;
  --gmap-poi-hue: #148F77;
} `, "",{"version":3,"sources":["webpack://./assets/styles/utils/theme.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;;EAExB,sBAAsB;EACtB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;;EAEnB,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,YAAY;EACZ,wBAAwB;;EAExB,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;;EAEvB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;;EAErB,gBAAgB;EAChB,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;;EAExB,sBAAsB;EACtB,uBAAuB;;EAEvB,mBAAmB;;EAEnB,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;;EAEnB,mCAAmC;EACnC,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,yBAAyB;EACzB,wBAAwB;;EAExB,kCAAkC;EAClC,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;;EAE1B,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;;EAErB,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;EACzB,uBAAuB;AACzB","sourcesContent":[":root {\r\n  --c-bkg-body: #f8f9fa;\r\n  --c-bkg-card: #ffffff;\r\n  --c-bkg-sidebar: #ffffff;\r\n\r\n  --c-text-base: #212529;\r\n  --c-text-muted: #6c757d;\r\n\r\n  --c-border: #e2e5e8;\r\n\r\n  --c-primary: #4b7cf3;\r\n  --c-primary-hover: #3a6bd8;\r\n  --c-secondary: #6c757d;\r\n  --c-secondary-hover: #5a6268;\r\n  --c-success: #2ecc71;\r\n  --c-danger: #e74c3c;\r\n  \r\n  /* Vector map colors */\r\n  --vmap-bg-color: #ffffff;\r\n  --vmap-border-color: #ffffff;\r\n  --vmap-region-color: #e4ecef;\r\n  --vmap-marker-fill: #ffffff;\r\n  --vmap-marker-stroke: #000000;\r\n  --vmap-hover-color: #ffffff;\r\n  --vmap-selected-color: #c9dfaf;\r\n  --vmap-scale-start: #03a9f3;\r\n  --vmap-scale-end: #02a7f1;\r\n  --vmap-scale-light: #b6d6ff;\r\n  --vmap-scale-dark: #005ace;\r\n  \r\n  /* Skycons */\r\n  --skycons-color: #ff6849;\r\n  \r\n  /* Sparkline colors */\r\n  --sparkline-success: #4caf50;\r\n  --sparkline-purple: #9675ce;\r\n  --sparkline-info: #03a9f3;\r\n  --sparkline-danger: #f96262;\r\n  --sparkline-light: #aaf;\r\n  \r\n  /* Loader */\r\n  --loader-bg: #ffffff;\r\n  --spinner-bg: #333333;\r\n  \r\n  /* Google Maps */\r\n  --gmap-landscape-hue: #FFBB00;\r\n  --gmap-highway-hue: #FFC200;\r\n  --gmap-road-hue: #FF0300;\r\n  --gmap-water-hue: #0078FF;\r\n  --gmap-poi-hue: #00FF6A;\r\n}\r\n\r\n[data-theme=\"dark\"] {\r\n  --c-bkg-body: #181a1f;\r\n  --c-bkg-card: #20232a;\r\n  --c-bkg-sidebar: #20232a;\r\n\r\n  --c-text-base: #e8eaed;\r\n  --c-text-muted: #9ca3af;\r\n\r\n  --c-border: #2b2f36;\r\n\r\n  --c-primary: #4b7cf3;\r\n  --c-primary-hover: #3a6bd8;\r\n  --c-secondary: #6c757d;\r\n  --c-secondary-hover: #5a6268;\r\n  --c-success: #32d48e;\r\n  --c-danger: #ff6b6b;\r\n  \r\n  /* Vector map colors - dark theme */\r\n  --vmap-bg-color: #20232a;\r\n  --vmap-border-color: #2b2f36;\r\n  --vmap-region-color: #2b2f36;\r\n  --vmap-marker-fill: #e8eaed;\r\n  --vmap-marker-stroke: #9ca3af;\r\n  --vmap-hover-color: #181a1f;\r\n  --vmap-selected-color: #4b5563;\r\n  --vmap-scale-start: #3b82f6;\r\n  --vmap-scale-end: #1d4ed8;\r\n  --vmap-scale-light: #1e40af;\r\n  --vmap-scale-dark: #60a5fa;\r\n  \r\n  /* Skycons - dark theme */\r\n  --skycons-color: #f97316;\r\n  \r\n  /* Sparkline colors - dark theme */\r\n  --sparkline-success: #10b981;\r\n  --sparkline-purple: #a855f7;\r\n  --sparkline-info: #3b82f6;\r\n  --sparkline-danger: #ef4444;\r\n  --sparkline-light: #60a5fa;\r\n  \r\n  /* Loader - dark theme */\r\n  --loader-bg: #181a1f;\r\n  --spinner-bg: #e8eaed;\r\n  \r\n  /* Google Maps - dark theme */\r\n  --gmap-landscape-hue: #D4AC0D;\r\n  --gmap-highway-hue: #E6AC00;\r\n  --gmap-road-hue: #CC2900;\r\n  --gmap-water-hue: #1B4F72;\r\n  --gmap-poi-hue: #148F77;\r\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
